import { render, staticRenderFns } from "./aTestComp2.vue?vue&type=template&id=27a6ee43"
import script from "./aTestComp2.vue?vue&type=script&lang=js"
export * from "./aTestComp2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports